import * as React from 'react';

import {CTABanner} from 'shells/cta-banner/cta-banner';
import {UserIcon} from 'shells/icon/svg/user-icon';

import styles from './banner.module.css';

type Props = {
    width: number;
    onClick: () => void;
};

export function UserAssignmentsCtaBanner(props: Props) {
    return (
        <div style={{width: props.width}} className={styles['banner-container']}>
            <CTABanner
                icon={UserIcon}
                title='Automate lead assignments'
                text='Distribute leads to your team members based on custom rules.'
                buttonText='Get started'
                maxWidth={null}
                onPrimaryAction={props.onClick}
            />
        </div>
    );
}
